import { SET_MSHOP_BOTTOM_OVERRIDE, ENABLE_MSHOP_BOTTOM_OVERRIDE } from '../actions';
const initialState = {
    iOSMShopBottomOverride: 0,
    enableIOSMShopBottomOverride: false,
};
export function MShopReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MSHOP_BOTTOM_OVERRIDE:
            return Object.assign(Object.assign({}, state), { iOSMShopBottomOverride: action.payload.iOSMShopBottomOverride });
        case ENABLE_MSHOP_BOTTOM_OVERRIDE:
            return Object.assign(Object.assign({}, state), { enableIOSMShopBottomOverride: action.payload.enableIOSMShopBottomOverride });
        default:
            return state;
    }
}
